/* External dependencies */
import { gql } from '@apollo/client';

export const updateOrderMutation = gql`
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
      name
      trackingNumber
      parcelCount
      status
      deliveryAddress {
        address
      }
      store {
        name
      }
    }
  }
`;
